"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokensPopoverComponent = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var TokensPanelController_1 = __importDefault(require("../../../Actions/Tokens/TokensPanelController"));
var TelemetryTypes_1 = require("@CommonFrontendBackend/Tokens/TelemetryTypes");
var CommonNavigationBarPopover_1 = require("Project/TopNavigationBar/DefaultNavigationButtons/PopoverComponents/CommonNavigationBarPopover");
var TokensPopoverComponent = (function (_super) {
    __extends(TokensPopoverComponent, _super);
    function TokensPopoverComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onButtonClick = function (isVisible) {
            if (isVisible && _this.props.projectStore.isTemplate) {
                _this.props.telemetry.track(TelemetryTypes_1.TokensEvents.TokensViewed, {}, { blockIntercom: true });
            }
        };
        return _this;
    }
    TokensPopoverComponent.prototype.render = function () {
        var _a = this.props, action = _a.action, projectStore = _a.projectStore, modal = _a.modal, tokenStore = _a.tokenStore, tokenViewStore = _a.tokenViewStore, telemetry = _a.telemetry, tokenReplacementStore = _a.tokenReplacementStore, usingFeature = _a.usingFeature, dragStore = _a.dragStore, isUserAdmin = _a.isUserAdmin;
        return (react_1.default.createElement(CommonNavigationBarPopover_1.CommonNavigationBarPopover, { action: action, childClassname: "tokens-popover-container", ignoreElements: [".tokens-panel", ".tokens-panel__option-menu", ".tokens-panel__modal", ".token-linking"], onButtonClick: this.onButtonClick },
            react_1.default.createElement(TokensPanelController_1.default, { projectStore: projectStore, modal: modal, tokenStore: tokenStore, tokenViewStore: tokenViewStore, telemetry: telemetry, tokenReplacementStore: tokenReplacementStore, usingFeature: usingFeature, dragStore: dragStore, isUserAdmin: isUserAdmin })));
    };
    TokensPopoverComponent = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], TokensPopoverComponent);
    return TokensPopoverComponent;
}(react_1.default.Component));
exports.TokensPopoverComponent = TokensPopoverComponent;
